import { render, staticRenderFns } from "./RuleEdit.vue?vue&type=template&id=741f2939&"
import script from "./RuleEdit.vue?vue&type=script&lang=js&"
export * from "./RuleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports